import React, { lazy, Suspense } from 'react';
import { createBrowserRouter, Navigate, Outlet } from 'react-router-dom';
import routes, { getRoute } from '../routes/route';
import { revalidateOn } from './utils/util';
import PublicRoute from '../components/atoms/publicRoute/publicRoute';
import LoadingSpinner from '../components/atoms/loadingSpinner/loadingSpinner';
import LoginPage from '../components/pages/loginPage/loginPage';
import { appRoutes } from './routeModules/index.routes';
import { loaders } from './loaders/index.loader';
import NotFoundPage from '../components/pages/error/notFoundPage';
const AppManagerPage = lazy(() => import('../components/pages/appManager/appManager'));
const VideoManagerPage = lazy(() => import('../components/pages/videoManagerPage/videoManagerPage'));
const HomePage = lazy(() => import('../components/pages/homePage/homePage'));
const MainHubsPage = lazy(() => import('../components/pages/mainHubPage/mainHubsPage'));
const AdminPage = lazy(() => import('../components/pages/adminPage/adminPage'));
const DebugPage = lazy(() => import('../components/pages/debugPage/debugPage'));
const SportRoomPage = lazy(() => import('../components/pages/sportRoomPage/sportRoomPage'));
const MainHubPage = lazy(() => import('../components/pages/mainHubPage/mainHubPage'));
const ScoreboardPage = lazy(() => import('../components/pages/scoreboardPage/scoreboardPage'));
const ClientPortalPage = lazy(() => import('../components/pages/clientPortal/clientPortalPage'));
const wrap = (node) => (
  <Suspense fallback={<LoadingSpinner />}>
    {node}
  </Suspense>
);

export const router = createBrowserRouter([
  {
    path: getRoute(routes.LOGIN),
    element: wrap(
      <PublicRoute>
        <LoginPage />
      </PublicRoute>
    ),
  },
  {
    path: getRoute(routes.HOME_PAGE),
    element: wrap(
      <PublicRoute restricted>
        <HomePage />
      </PublicRoute>
    ),
  },
  {
    path: getRoute(routes.VIDEO_MANAGER),
    element: wrap(
      <PublicRoute restricted>
        <VideoManagerPage />
      </PublicRoute>
    ),
    children: appRoutes.videoManagerRoutes,
  },
  {
    path: getRoute(routes.ADMIN),
    element: wrap(
      <PublicRoute restricted>
        <AdminPage />
      </PublicRoute>
    ),
    children: appRoutes.adminRoutes,
  },
  {
    path: getRoute(routes.DEBUG),
    element: wrap(
      <PublicRoute restricted>
        <DebugPage />
      </PublicRoute>
    ),
    children: appRoutes.debugRoutes,
  },
  {
    id: 'appManager',
    path: getRoute(routes.APP_MANAGER),
    loader: loaders.appManagerLoader,
    shouldRevalidate: ({ currentUrl, nextUrl }) => {
      if (currentUrl.pathname !== nextUrl.pathname) return true;

      return revalidateOn('wlplay', 'configs')({
        currentUrl,
        nextUrl,
      });
    },
    element: wrap(
      <PublicRoute restricted>
        <AppManagerPage />
      </PublicRoute>
    ),
    children: appRoutes.appManagerRoutes,
  },
  {
    path: getRoute(routes.MAIN_HUBS),
    element: wrap(
      <PublicRoute restricted>
        <MainHubsPage />
      </PublicRoute>
    ),
  },
//  {
//   path: '/wlpro/:mainHubSlugName',
//   element: <Outlet />,
//   children: [

//     // MAIN HUB
//     {
//       loader: loaders.mainHubLoader,
//       element: wrap(
//         <PublicRoute restricted>
//           <MainHubPage />
//         </PublicRoute>
//       ),
//       children: appRoutes.mainHubRoutes,
//     },

//     // SPORT ROOM
//     {
//       path: 'space/:spaceSlugName',
//       loader: loaders.sportRoomLoader,
//       element: wrap(
//         <PublicRoute restricted>
//           <SportRoomPage />
//         </PublicRoute>
//       ),
//       errorElement: wrap(
//         <PublicRoute restricted>
//           <SportRoomPage errorPage={<NotFoundPage />} />
//         </PublicRoute>
//       ),
//       children: appRoutes.sportRoomRoutes,
//     },
//   ],
// },
{
    id: 'mainHub',
    path: getRoute(routes.MAIN_HUB),
    loader: loaders.mainHubLoader,
    element: <Outlet />,
    children: [
        {
            element: wrap(
                <PublicRoute restricted>
                    <MainHubPage />
                </PublicRoute>
            ),
            children: appRoutes.mainHubRoutes,
        },
    ],
},
{
    id: 'space',
    path: '/wlpro/:mainHubSlugName/space/:spaceSlugName',
    loader: loaders.sportRoomLoader,
    element: wrap(
        <PublicRoute restricted>
            <SportRoomPage />
        </PublicRoute>
    ),
    errorElement: wrap(
        <PublicRoute restricted>
            <SportRoomPage errorPage={<NotFoundPage />} />
        </PublicRoute>
    ),
    children: appRoutes.sportRoomRoutes,
},
  {
    path: getRoute(routes.SCOREBOARD),
    element: wrap(
      <PublicRoute restricted>
        <ScoreboardPage />
      </PublicRoute>
    ),
  },
  {
    path: getRoute(routes.CLIENT_PORTAL),
    element: wrap(
      <PublicRoute restricted>
        <ClientPortalPage />
      </PublicRoute>
    ),
    children: appRoutes.clientPortalRoutes,
  },
  {
    path: '*',
    element: <Navigate to={getRoute(routes.HOME_PAGE)} replace />,
  },
]);